import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "clearfix" };
const _hoisted_3 = { class: "clearfix" };
const _hoisted_4 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_5 = { class: "input-group top_search" };
const _hoisted_6 = { class: "input-group-btn" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* HOISTED */);
const _hoisted_8 = [
    _hoisted_7
];
const _hoisted_9 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_10 = { class: "checkbox-wrapper" };
const _hoisted_11 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_12 = { class: "float-end float-start-sm" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-plus" }, null, -1 /* HOISTED */);
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Add System Category", -1 /* HOISTED */);
const _hoisted_15 = { class: "col-xs-12 col-sm-12" };
const _hoisted_16 = { class: "card bg-white data-grid company-detail-grid detached" };
const _hoisted_17 = { class: "table table-hover small bottom0 pw100" };
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("th", { class: "text-center hidden-sm w40 no-min-width" }, null, -1 /* HOISTED */);
const _hoisted_19 = { class: "text-center hidden-sm" };
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-pencil" }, null, -1 /* HOISTED */);
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-trash" }, null, -1 /* HOISTED */);
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-refresh" }, null, -1 /* HOISTED */);
const _hoisted_23 = ["onClick"];
const _hoisted_24 = { key: 0 };
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("td", {
    class: "text-center",
    colspan: "2"
}, [
    /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_26 = [
    _hoisted_25
];
const _hoisted_27 = { class: "data-grid-footer clearfix detached pw100" };
const _hoisted_28 = { class: "clearfix" };
const _hoisted_29 = { class: "col-sm-12 col-xs-12 col-md-12 bottom10" };
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tCategory Name *\r\n\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_31 = { class: "invalid-feedback" };
const _hoisted_32 = { class: "float-end float-start-sm" };
const _hoisted_33 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* HOISTED */);
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* HOISTED */);
const _hoisted_35 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-refresh" }, null, -1 /* HOISTED */);
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_button = _resolveComponent("b-button");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
    const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider");
    const _component_b_dropdown = _resolveComponent("b-dropdown");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_modal = _resolveComponent("b-modal");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_b_form_input, {
                            type: "text",
                            modelValue: _ctx.query.keywords,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.query.keywords) = $event)),
                            modelModifiers: { trim: true },
                            placeholder: "Search for...",
                            onKeyup: _withKeys(_ctx.search, ["enter"]),
                            required: ""
                        }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                        _createTextVNode(),
                        _createElementVNode("span", _hoisted_6, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-default",
                                onClick: _cache[1] || (_cache[1] =
                                    //@ts-ignore
                                    (...args) => (_ctx.search && _ctx.search(...args)))
                            }, _hoisted_8)
                        ])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_b_form_checkbox, {
                            id: "includeArchivedContacts",
                            modelValue: _ctx.query.includeDeleted,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.query.includeDeleted) = $event)),
                            size: "lg"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode("\r\n\t\t\t\t\t\t\tShow archived\r\n\t\t\t\t\t\t")
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_b_button, {
                            variant: "primary",
                            onClick: _ctx.add
                        }, {
                            default: _withCtx(() => [
                                _hoisted_13,
                                _hoisted_14
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"])
                    ])
                ])
            ]),
            _createTextVNode(),
            _withDirectives(_createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("table", _hoisted_17, [
                        _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _hoisted_18,
                                _createTextVNode(),
                                _createElementVNode("th", null, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'Name', title: 'Category Name' }
                                    }, null, 8 /* PROPS */, ["sorter"])
                                ])
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                    class: _normalizeClass({ 'deleted': item.whenDeleted })
                                }, [
                                    _createElementVNode("td", _hoisted_19, [
                                        _createVNode(_component_b_dropdown, {
                                            variant: "outline-secondary dots",
                                            size: "sm",
                                            onClick: ($event) => (_ctx.edit(item))
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_b_dropdown_item, {
                                                    onClick: ($event) => (_ctx.edit(item))
                                                }, {
                                                    default: _withCtx(() => [
                                                        _hoisted_20,
                                                        _createTextVNode(" Edit\r\n\t\t\t\t\t\t\t\t\t\t")
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                                                _createTextVNode(),
                                                _createVNode(_component_b_dropdown_divider),
                                                _createTextVNode(),
                                                _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                    onClick: ($event) => (_ctx.archive(item))
                                                }, {
                                                    default: _withCtx(() => [
                                                        _hoisted_21,
                                                        _createTextVNode(" Archive\r\n\t\t\t\t\t\t\t\t\t\t")
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]), [
                                                    [_vShow, !item.whenDeleted]
                                                ]),
                                                _createTextVNode(),
                                                _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                    onClick: ($event) => (_ctx.restore(item))
                                                }, {
                                                    default: _withCtx(() => [
                                                        _hoisted_22,
                                                        _createTextVNode(" Restore\r\n\t\t\t\t\t\t\t\t\t\t")
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]), [
                                                    [_vShow, item.whenDeleted]
                                                ])
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            class: "blue pointer",
                                            onClick: ($event) => (_ctx.edit(item))
                                        }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_23)
                                    ])
                                ], 2 /* CLASS */));
                            }), 256 /* UNKEYED_FRAGMENT */))
                        ]),
                        _createTextVNode(),
                        _createElementVNode("tfoot", null, [
                            (_ctx.noData)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_24, _hoisted_26))
                                : _createCommentVNode("v-if", true)
                        ])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_b_pagination, {
                        class: "float-end",
                        modelValue: _ctx.query.pageNo,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.query.pageNo) = $event)),
                        "per-page": _ctx.query.pageSize,
                        "total-rows": _ctx.data.recordCount,
                        "hide-ellipsis": true,
                        disabled: _ctx.working
                    }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                ])
            ], 512 /* NEED_PATCH */), [
                [_vShow, _ctx.searchAttempted]
            ])
        ]),
        _createTextVNode(),
        _createVNode(_component_b_modal, {
            id: "system_category_popup",
            modelValue: _ctx.editingModel,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.editingModel) = $event)),
            "header-bg-variant": "normal",
            size: "md"
        }, {
            title: _withCtx(() => [
                _createTextVNode("\r\n\t\t\t\tSystem Category\r\n\t\t\t")
            ]),
            footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_32, [
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "primary",
                        onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.save(_ctx.model)))
                    }, {
                        default: _withCtx(() => [
                            _hoisted_33,
                            _createTextVNode(" Save\r\n\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createTextVNode(),
                    _withDirectives(_createVNode(_component_b_button, {
                        type: "button",
                        variant: "danger",
                        onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.archive(_ctx.model)))
                    }, {
                        default: _withCtx(() => [
                            _hoisted_34,
                            _createTextVNode(" Archive\r\n\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 512 /* NEED_PATCH */), [
                        [_vShow, _ctx.model.modelId && !_ctx.model.whenDeleted]
                    ]),
                    _createTextVNode(),
                    _withDirectives(_createVNode(_component_b_button, {
                        type: "button",
                        variant: "warning",
                        onClick: _cache[7] || (_cache[7] = ($event) => (_ctx.restore(_ctx.model)))
                    }, {
                        default: _withCtx(() => [
                            _hoisted_35,
                            _createTextVNode(" Restore\r\n\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 512 /* NEED_PATCH */), [
                        [_vShow, _ctx.model.modelId && _ctx.model.whenDeleted]
                    ]),
                    _createTextVNode(),
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "secondary",
                        onClick: _ctx.cancel
                    }, {
                        default: _withCtx(() => [
                            _hoisted_36,
                            _createTextVNode(" Close\r\n\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ])
            ]),
            default: _withCtx(() => [
                _createTextVNode(),
                _createVNode(_component_b_container, { clearfix: "" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                                _hoisted_30,
                                _createTextVNode(),
                                _createVNode(_component_b_form_input, _mergeProps(_ctx.nameVal, {
                                    type: "text",
                                    modelValue: _ctx.model.name,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.model.name) = $event)),
                                    modelModifiers: { trim: true },
                                    name: "name",
                                    class: { 'is-invalid': _ctx.errors && _ctx.errors.name },
                                    maxlength: "250"
                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                _createTextVNode(),
                                _withDirectives(_createElementVNode("div", _hoisted_31, "\r\n\t\t\t\t\t\t\t* Please enter a category name\r\n\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                    [_vShow, _ctx.errors && _ctx.errors.name]
                                ])
                            ])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }),
                _createTextVNode()
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"])
    ]));
}
